import axios from "axios"
import { URI_LOCAL } from "../data/constants"

export const getLaunchesLogs = () => {
    const response = axios.get(`${URI_LOCAL}Logs/get_launched_logs`)
    return response
}